import { render, staticRenderFns } from "./SOS.vue?vue&type=template&id=40457332&scoped=true"
import script from "./SOS.vue?vue&type=script&lang=js"
export * from "./SOS.vue?vue&type=script&lang=js"
import style0 from "./SOS.vue?vue&type=style&index=0&id=40457332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40457332",
  null
  
)

export default component.exports